import { render, staticRenderFns } from "./curation-details.vue?vue&type=template&id=61db8fd9"
import script from "./curation-details.vue?vue&type=script&lang=js"
export * from "./curation-details.vue?vue&type=script&lang=js"
import style0 from "./curation-details.vue?vue&type=style&index=0&id=61db8fd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports